$(function () {

    // Global ajax settings
    $.ajaxSetup({
        statusCode: {
            419: function () {
                $.alert({
                    columnClass: 'col-md-6',
                    icon:        'ri-alert-fill ri-xxs',
                    title:       transAccionAtencion,
                    content:     transErrorSesionExpirada,
                    type:        'orange',
                    buttons:     {
                        reload: {
                            text:     transAccionRecargar,
                            btnClass: 'btn btn-danger float-end',
                            action:   function () {
                                window.location.reload();
                            },
                        },
                    },
                });
            }
        },
        error:      function (jqXHR, textStatus, errorThrown) {
            if (
                $.inArray(jqXHR.status, [
                    // 0, // El 0 es un ajax abortado, no hacemos nada
                    422,
                    419
                ]) === -1 &&
                (
                    typeof jqXHR.responseJSON === 'undefined' ||
                    typeof jqXHR.responseJSON.message === 'undefined'
                )
            ) {
                if (jqXHR.status !== 0) {
                    pNotifyErrorConnection();
                }
            }
        },
        headers:    {
            'Cache-Control': 'no-cache',
            'X-CSRF-TOKEN':  _token,
        }
    });

});
